import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MapIncomeToBusinessSegmentRoutingModule } from './map-income-to-business-segment-routing.module';
import { MapIncomeToBusinessSegmentFormComponent } from './map-income-to-business-segment-form/map-income-to-business-segment-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    MapIncomeToBusinessSegmentFormComponent
  ],
  imports: [
    CommonModule,
    MapIncomeToBusinessSegmentRoutingModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    SharedModule,
    FormsModule,
  ]
})
export class MapIncomeToBusinessSegmentModule { }
